import type { AccountInfo } from '@azure/msal-browser';

// B2C accounts may have an empty username; the custom policy exposes the email claim instead.
export function getLoginHint(account: AccountInfo): string {
  const email = account.idTokenClaims?.email;
  return account.username || (typeof email === 'string' ? email : '');
}
